<template>
	<div class="rows" v-if="getList.length > 0">
		<div :class="[options.wrapperClass, { 'no-border': isAlone }]">
			<div
				class="extraFields-inner"
				:class="{ 'flex-column': options.info }"
				v-for="(input, i) in getList"
				:key="i"
			>
				<div class="extra-input-label d-table w-100 text-center">{{ i + 1 }}. {{ options.label }}</div>
				<div class="fs-desc mb-15px" v-if="options.info">{{ options.info }}</div>
				<div class="d-flex" :class="{ 'w-100': options.fullWidth }">
					<div class="d-grid extra-inputs form" :class="{ alone: isAlone }">
						<CalcElem
							v-for="(field, index) in computedFields"
							:key="index"
							:name="index"
							:options="field"
							:index="i"
							:ref="`${index}-${i}`"
						/>
					</div>
					<div class="trash-icon">
						<img
							src="/img/frontend/icons/trash.svg"
							title="Melléképület törlése"
							alt="Melléképület törlése"
							@click="deleteItem(i)"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import { mapGetters, mapMutations } from 'vuex';
import { cloneDeep, has } from 'lodash';

export default {
	mixins: [shared],
	computed: {
		...mapGetters(['getOutbuildingTypes', 'getOutbuildingLocations']),
		getList() {
			return this.$store.getters[this.options.list] ?? [];
		},
		isAlone() {
			return Object.keys(this.options.fields).length === 1;
		},
		computedFields() {
			const fields = cloneDeep(this.options.fields);

			if (this.options.inputGroup === 'outbuildings') {
				if (has(fields, 'type_id')) {
					fields.type_id.choices = this.getOutbuildingTypes;
				}

				if (has(fields, 'location_id')) {
					fields.location_id.choices = { ...fields.location_id.choices, ...this.getOutbuildingLocations };
				}
			}

			return fields;
		},
	},
	methods: {
		...mapMutations(['showPopup']),
		deleteItem(index) {
			this.$store.commit(this.options.delete, index);
		},
	},
};
</script>

<style lang="scss" scoped>
.extra-inputs {
	grid-template-rows: 1fr;
	grid-template-columns: 1fr 1fr;
	margin-right: 30px;
	column-gap: 15px;
	width: 100%;

	@media only screen and (max-width: 575px) {
		display: flex;
		flex-direction: column;
	}
}

.notifier {
	grid-column: 1 / -1;
	max-width: 743px;
}

.outbuilding-same {
	display: grid;
	grid-column: 1 / 3;
	justify-content: center;
}

.alone {
	grid-template-rows: 1fr;
	grid-template-columns: 1fr;
	padding: 0 30px;
}

.no-border {
	&::before {
		content: unset;
	}
}
</style>
